export default "__VITE_ASSET__biOYTRZO__"